import React, { useState, useEffect } from "react";
import Button from "../controls/button";
import CustomPopover from "../popover/Popover";
import CustomButton from "../../components/controls/button/Button";
import { CalendarIcon, FileDownSvg, Cross } from "../../modules/default-svg";
import CheckboxInputStateSave from "../controls/checkboxStateSave/CheckboxStateSave";
import styles from "./ExportButton.module.scss";
import dayjs from "dayjs";
import CustomInput from "../../components/controls/input/customInput/CustomInput";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import { exportFormats, exportPeriods, exportTypes, getLabelByType } from "../../helpers/utils";
import exportService from "../../store/services/export.service";
import { useDispatch } from "react-redux";
import { generalActions } from "../../store/actions";
import { Download, X } from "lucide-react";
import { use } from "react";

export default function ExportButton({ config }) {
  const [exportConfig, setExportConfig] = useState({
    category: config.category,
    parent: config.parent,
    parentId: config.parentId,
    cashflowYear: config.cashflowYear || null,
    type: 0,
    format: 0,
    startDate: null,
    endDate: null,
    all: false,
  });
  const [selectedPeriod, setSelectedPeriod] = useState(0);
  const [openPopover, setIsOpenPopover] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const today = dayjs();

  const init = () => {
    //Runbooks
    setExportConfig((config) => ({ ...config, format: 0, type: 0 }));
    handleExportPeriodChange(0);
    setIsOpenPopover(true);

  };

  useEffect(() => {
    if (config) {
      setExportConfig((prevConfig) => ({
        ...config, format: 0, type: 0
      }));
    }
  }, [config]);

  const handleCustomDatesChange = (type, date) => {
    var formatedDate = dayjs(date).format("YYYY-MM-DD").toString();
    if (type === "start")
      setExportConfig((config) => ({ ...config, startDate: formatedDate }));
    else if (type === "end")
      setExportConfig((config) => ({ ...config, endDate: formatedDate }));
  };

  const handleExportPeriodChange = (index) => {
    setSelectedPeriod(index);
    let startDate, endDate;
    let all = false;

    switch (index) {
      case 0:
        startDate = today.subtract(7, "day").format("YYYY-MM-DD").toString();
        endDate = today.format("YYYY-MM-DD").toString();
        break;
      case 1:
        startDate = today.subtract(30, "day").format("YYYY-MM-DD").toString();
        endDate = today.format("YYYY-MM-DD").toString();
        break;
      case 2:
        all = true;
        startDate = endDate = null;
        break;
      case 3:
        startDate = endDate = today.format("YYYY-MM-DD").toString();
        break;
    }

    setExportConfig((config) => ({
      ...config,
      startDate: startDate,
      endDate: endDate,
      all: all,
    }));
  };

  const getDefaultExportFileName = () => {
    switch (exportConfig.category) {
      case 0:
        return "Budgets";
      case 1:
        return "CashFlow(COA)";
      case 2:
        return "Purchase_Orders";
      case 3:
        return "Invoices_Registry";
      case 4:
        return "Runbooks";
      case 5:
        return "Timeline";
    }
  }

  const handleExport = () => {
    setIsLoading(true);
    let exportParams = { ...exportConfig };
    if (exportConfig.category === 1) {
      exportParams = {
        category: exportConfig.category,
        parent: exportConfig.parent,
        parentId: exportConfig.parentId,
        cashflowYear: exportConfig.cashflowYear || null,
        type: exportConfig.type,
        format: 1,
        all: true
      }
    }
    else if (exportConfig.category === 4) {
      exportParams = {
        projectId: exportConfig.parentId,
        format: exportConfig.format,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        category: exportConfig.category,
      };
    }
    else if (exportConfig.category === 5) {
      exportParams = {
        format: exportConfig.format,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        category: exportConfig.category,
      };

      switch (exportConfig.parent) {
        case 1:
          exportParams = { ...exportParams, portfolioId: exportConfig.parentId }
          break;
        case 2:
          exportParams = { ...exportParams, programId: exportConfig.parentId }
          break;
        case 3:
          exportParams = { ...exportParams, projectId: exportConfig.parentId }
          break;
        case 4:
          exportParams = { ...exportParams, scopeId: exportConfig.parentId }
          break;
        default:
          break;
      }
    }

    exportService
      .getExport(exportParams)
      .then((response) => {
        const contentDisposition = response.headers["content-disposition"];
        let fileName = getDefaultExportFileName();

        let fileExtension = "csv";

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            fileName = match[1].split(".")[0];
          }
        }

        const fileType = response.headers.getContentType();
        if (fileType.includes("csv")) {
          fileExtension = "csv";
        } else if (fileType.includes("spreadsheet")) {
          fileExtension = "xlsx";
        }

        const blob = new Blob([response.data], { type: fileType });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}.${fileExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        dispatch(
          generalActions.showToast({
            title: "Export successful",
            type: "success",
          })
        );
      })
      .catch((error) => {
        console.error("Download failed:", error);
        dispatch(
          generalActions.showToast({
            title: "Export Failed. Please try again.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
        setIsOpenPopover(false);
      });
  };

  return (
    <div>
      <CustomPopover
        icon={
          <Button
            btnClass={`d_btn ms-12 d_btn_primary ${styles.exportButton}`}
            icon={<FileDownSvg />}
            label="Export"
            clickHandler={() => init()}
          />
        }
        minWidth={400}
        PopSurfaceClass="mt-1"
        status={openPopover}
      >
        {
          <div className="text-[#342c82] ">
            <div className="d-flex justify-content-end align-items-center mb-2">
              <div onClick={() => setIsOpenPopover(false)}>
                <Cross />
              </div>
            </div>
            <div className="d-flex flex-column">
              <div className={`${styles.filterPopoverBody} FilterPopoverBody`}>
                <div className="FilterPopoverBodyScroll">
                  <div className="d-flex row align-items-center mb-3">
                    {exportConfig.category !== 1 && (
                      <>
                        <div className="col-2">Format</div>
                        <div className="col-4 align-items-center">
                          <DropDown
                            dropDownwd="w-70"
                            showLabel={false}
                            options={exportFormats}
                            defaultVal={getLabelByType(
                              "exportFormat",
                              exportConfig.format
                            )}
                            onChange={(e) => {
                              setExportConfig((config) => ({
                                ...config,
                                format: e,
                              }))
                            }}
                          />
                        </div>
                      </>
                    )
                    }
                    {(exportConfig.category === 0 || exportConfig.category === 1) &&
                      (
                        <>
                          <div className="col-2">Type</div>
                          <div className="col-4 align-items-center">
                            <DropDown
                              dropDownwd="w-70"
                              showLabel={false}
                              options={exportTypes}
                              defaultVal={getLabelByType(
                                "exportType",
                                exportConfig.type
                              )}
                              onChange={(e) => {
                                setExportConfig((config) => ({
                                  ...config,
                                  type: e,
                                }))
                              }}
                            />
                          </div>
                        </>
                      )}

                  </div>
                  {exportConfig.category !== 1 && exportConfig.category !== 4 && exportConfig.category !== 5 && (
                    <div className="d-flex row align-items-center mb-3">
                      <div className="col-2">Period</div>
                      <div className="col-10 align-items-center">
                        <DropDown
                          dropDownwd="w-70"
                          showLabel={false}
                          options={exportPeriods}
                          defaultVal={getLabelByType(
                            "exportPeriod",
                            selectedPeriod
                          )}
                          onChange={handleExportPeriodChange}
                        />
                        <div className={styles.options}>
                          {selectedPeriod === 3 && (
                            <div>
                              <div className={styles.rangeDateWrapper}>
                                <div className="text-xs h-[43px] flex items-center justify-center gap-1">
                                  <CustomInput
                                    type="date"
                                    width="105px"
                                    DateStyleClass="date-input DatePickerInput"
                                    DateStyles={{ fontSize: "14px" }}
                                    maxDate={exportConfig.endDate}
                                    handleChange={(value) => {
                                      handleCustomDatesChange("start", value);
                                    }}
                                    value={
                                      exportConfig.startDate ?? today.toDate()
                                    }
                                  />
                                  <span className="text-gray-500 text-sm">
                                    -
                                  </span>
                                  <CustomInput
                                    type="date"
                                    width="105px"
                                    DateStyleClass="date-input DatePickerInput"
                                    DateStyles={{ fontSize: "14px" }}
                                    minDate={exportConfig.startDate}
                                    handleChange={(value) => {
                                      handleCustomDatesChange("end", value);
                                    }}
                                    value={
                                      exportConfig.endDate ?? today.toDate()
                                    }
                                  />
                                </div>
                                <CalendarIcon />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-end gap-2 justify-content-end FilterPopoverFooter px-[10px]">
              <CustomButton
                btnClass="d_btn d_btn_white d_btn_whiteXsm"
                label="Cancel"
                icon={<X size={16} />}
                clickHandler={() => setIsOpenPopover(false)}
              />
              <CustomButton
                btnClass="d_btn d_btn_primary d_btn_primaryXsm"
                label="Export"
                icon={<Download size={16} />}
                clickHandler={() => {
                  handleExport();
                }}
                showLoading={isLoading}
              />
            </div>
          </div>
        }
      </CustomPopover>
    </div>
  );
}
